<template>
  <div class="main">
    <b-table :data="data">
      <template slot-scope="props">
        <b-table-column field="name" label="Supplier Issues">
          {{ getFromParts(props.row.name, 0) }}
        </b-table-column>
        <b-table-column field="bug" label="Software Issues">
          {{ getFromParts(props.row.name, 1) }}
        </b-table-column>
        <b-table-column field="status" label="Service Status">
          <span class="tag" :class="type(props.row.completed)">
            <span v-if="props.row.completed === 1">
              Fixed {{ props.row.completed_at }}
            </span>
            <span v-else>
              Active
            </span>
          </span>
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: "AsanaStoresTable",
  methods: {
    getFromParts(value, index) {
      const parts = value.split("|");
      return parts[index].trim();
    },
    type(value) {
      const number = parseFloat(value);
      if (number === 1) {
        return "is-success";
      }
      return "is-warning";
    }
  },
  props: {
    data: Array
  }
};
</script>

<style scoped></style>
